import { useEffect, useState } from 'react';
import { usePersonsTrackDensity } from '../hooks/usePersonsTrackDensity';
import { usePersonsTrackLanes } from '../hooks/usePersonsTrackLanes';
import { PersonsLanesViewport } from './lanes/PersonsLanesViewport';
import { PersonsSummaryStrip } from './summary/PersonsSummaryStrip';

/**
 * Personas track body under the focus area (below Live Topics when both are on).
 *
 * Switches between the compact summary strip and the expanded per-person lanes
 * based on density settings. Owns shared hover state; the density toggle itself
 * lives in the focus-track header.
 */
export function PersonsTrackGroup() {
  const { density } = usePersonsTrackDensity();
  const { lanes, range, packed, hasPersonsInStream, isLoading } = usePersonsTrackLanes();
  const [hoveredLaneKey, setHoveredLaneKey] = useState<string | null>(null);

  // Header density toggle can collapse — clear hover chrome.
  useEffect(() => {
    if (density === 'summary') {
      setHoveredLaneKey(null);
    }
  }, [density]);

  // Same as live topics: hatched empty only when the loaded range has no persons.
  const showEmptyState = !isLoading && !hasPersonsInStream;

  if (density === 'lanes') {
    return (
      <PersonsLanesViewport
        lanes={lanes}
        range={range}
        hoveredLaneKey={hoveredLaneKey}
        onHoverLane={setHoveredLaneKey}
      />
    );
  }

  return (
    <PersonsSummaryStrip
      lanes={lanes}
      range={range}
      packed={packed}
      showEmptyState={showEmptyState}
      hoveredLaneKey={hoveredLaneKey}
      onHoverLane={setHoveredLaneKey}
    />
  );
}
